import React from 'react';

import './animation.css';
import { Container, StyledOverview1Link } from './styled';

const Idle = () => (
  <Container>
    <section className="animation">
      <span />
      <span />
      <span />
      <span />
      <span />
    </section>
    <StyledOverview1Link to="/">go to overview 1</StyledOverview1Link>
  </Container>
);
export default Idle;
